import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Link, useNavigate } from "react-router-dom";
import { removeFilterTitle } from "../../util/removeFilterTitle";
import {
  Box,
  Button,
  Grid,
  Hidden,
  TextField,
  Typography,
} from "@mui/material";
import swal from "sweetalert";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import _ from "lodash";
// import * as swal from 'sweetalert';
import Swal from "sweetalert2";
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import overlayFactory from "react-bootstrap-table2-overlay";
import { format } from "date-fns";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function IndustrialChallanShow() {

  //usestate declaration
  const [loading, setLoading] = useState(true);
  const [challanlist, setchallanlist] = useState([]);

  //displaying the challan details
  useEffect(() => {
    removeFilterTitle(".sr-only");
    axios.get(`api/show_inds_chalans`).then((res) => {
      if (res.status === 200) {
        setchallanlist(res.data.Chalans);
      }
      setLoading(false);
    });
  }, []);

  function add3Dots(string, limit) {
    var dots = "...";
    if (string.length > limit) {
      // you can also use substr instead of substring
      string = string.substring(0, limit) + dots;
    }

    return string;
  }

  //delete function
  const deleteUser = (e, id) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data= {user_id:userId,};
    const thisClicked = e.currentTarget;

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: true,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure , you want to delete this Details",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes,delete it!",
        confirmButtonColor: "#D10000",
        cancelButtonColor: "#00D100",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          axios.post(`api/delete_chalans/${id}`,data).then((res) => {
            if (res.data.status === 200) {
              thisClicked.closest("tr").remove();
            } else if (res.data.status === 404) {
              swal("Success", res.data.message, "success");
              thisClicked.innerText = "Delete";
            }
          });
          swalWithBootstrapButtons.fire(
            "Deleted!",
            "Category deleted successfully.",
            "success"
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          // swalWithBootstrapButtons.fire(
          //   'Cancelled',
          //   'Your imaginary file is safe :)',
          //   'error'
          // )
        }
      });
  };

  const currentMonth = format(new Date(), "MMM-yyyy");
  // console.log(columns);

  //colour palette
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      . Showing {from} to {to} of {size} Results"
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: challanlist.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  var add = add3Dots("address", 25);
  const ans = add3Dots("address", 25);

  const columns = [
    {
      dataField: "id",
      text: "ID",
    },
    {
      dataField: "memo_no",
      text: "Memo No",
    },
    {
      dataField: "party_code",
      text: "Party Code",
      filter: textFilter(),
    },
    {
        dataField: "vertical_type",
        text: "Vertical Type",
      },
    {
      dataField: "date",
      text: "Date",
      filter: textFilter(),
    },
    {
      dataField: "month_of_test",
      text: "Month of Test",
      filter: textFilter(),
    },
    /* {
    dataField: "category_id",
    text: "category_id",
  },
  {
    dataField: "sub_catgory_id",
    text: "sub_catgory_id",
  },*/
    /* {
    dataField: "category_details_id",
    text: "category_details_id",
    
  },*/
    {
      dataField: "remarks",
      text: "Remarks",
      filter: textFilter(),
    },

    {
      dataField: "action",
      text: "Actions",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        // console.log(row);
        const Chalans_id = row.id;
        // console.log(customerId);
        return (
          <ThemeProvider theme={theme}>
            <Grid container spacing={1}>
              <Grid item xs={2}>
                <Button
                  component={Link}
                  to={`/certificates/view_inds_chalans/${Chalans_id}`}
                  color="apple"
                  size="medium"
                  startIcon={<VisibilityIcon color="inherit" />}
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  component={Link}
                  to={`/certificates/edit_inds_challan/${Chalans_id}`}
                  color="apple"
                  size="medium"
                  startIcon={<EditIcon color="inherit" />}
                />
                 </Grid>
              <Grid item xs={2}>
                <Button
                  component={Link}
                  to={`/certificates/copy_inds_details/${Chalans_id}`}
                  color="apple"
                  size="medium"
                  startIcon={<ContentCopyIcon color="inherit" />}
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  onClick={(e) => deleteUser(e, Chalans_id)}
                  color="error"
                  size="medium"
                  startIcon={<DeleteIcon color="warning" />}
                />
              </Grid>
              
            </Grid>
          </ThemeProvider>
        );
      },
    },
  ];

  // console.log(challanlist[columns['4']['dataField']]);

  return (
    <div>
      <Navbar />
      <div className="card px-8 m-5">
        <div className="card-header">
          <div class="d-flex justify-content-between">
            <h4>Industrial Challan Details</h4>
            <ThemeProvider theme={theme}>
              <Button
                component={Link}
                to="/certificates/add_inds_challan"
                variant="contained"
                color="apple"
              >
                Add Challan
              </Button>
              {/*<Button component={Link} to="/edit_challan/${id}" variant='contained' color='apple'>Update Challan</Button>*/}
            </ThemeProvider>
          </div>
        </div>
        <BootstrapTable
          keyField="id"
          data={challanlist}
          columns={columns}
          hover
          condensed
          // pagination={paginationFactory(options)}
          filter={filterFactory()}
          // overlay={overlayFactory()}
        />
      </div>
    </div>
  );
}

export default IndustrialChallanShow;